import { Link } from "react-router-dom";
import type { EventProximityPhase, FeaturedEventRef } from "@tih/shared";
import { useCountdown } from "../../hooks/useCountdown";
import { formatWeekdayInKampala, formatOrdinalDayInKampala, formatMonthYearKampala } from "../../lib/eventDisplay";

type Props = {
  proximity: EventProximityPhase;
  featured: FeaturedEventRef | null;
  daysOut: number | null;
};

export function EventProximityBanner({ proximity, featured, daysOut }: Props) {
  const target = featured?.date ? Date.parse(featured.date) : 0;
  const { d, h, m } = useCountdown(target);

  if (!featured?.date) return null;
  if (proximity === "evergreen" || proximity === "live") return null;

  const { day, sup } = formatOrdinalDayInKampala(featured.date);
  const weekday = formatWeekdayInKampala(featured.date);
  const monthYear = formatMonthYearKampala(featured.date);

  const label =
    proximity === "eve"
      ? "Tomorrow is the night"
      : proximity === "afterglow"
        ? "Last night"
        : daysOut != null && daysOut > 0
          ? `${daysOut} day${daysOut === 1 ? "" : "s"} until the overnight`
          : "Upcoming overnight";

  return (
    <div className="participation-event-banner">
      <div className="participation-event-banner-text">
        <span className="participation-event-banner-k">{label}</span>
        <strong>
          {weekday}, {day}
          <sup>{sup}</sup> {monthYear}
        </strong>
        {featured.title && <span className="participation-event-banner-sub">{featured.title}</span>}
      </div>
      {(proximity === "announce" || proximity === "approach" || proximity === "countdown" || proximity === "eve") && (
        <div className="participation-event-banner-countdown" aria-label="Countdown">
          <span>
            <b>{d}</b>d
          </span>
          <span>
            <b>{h}</b>h
          </span>
          <span>
            <b>{m}</b>m
          </span>
        </div>
      )}
      <Link to="/event" className="btn btn-ghost participation-event-banner-cta">
        View event →
      </Link>
    </div>
  );
}
